import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import * as req from 'src/app/entities/request';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { KeyValueSet, LocalService, Status } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-printer-template-map-popup',
  templateUrl: './printer-template-map-popup.component.html',
  styleUrl: './printer-template-map-popup.component.scss'
})
export class PrinterTemplateMapPopupComponent {
  @ViewChild('content_receipt_template_map') content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() itemId: string | undefined = undefined;
  @Input() businessId: string;
  @Input() ctryCode: string;

  itemSourceTemplates: KeyValueSet[] = []; itemSourcePrinterNames: KeyValueSet[] = [];
  selectedKeysTemplates: string[] = []; selectedKeyPrinterName: string = '';
  title: string = '';
  loadedApi = 0;

  htmlId: string = '';
  elementIds: any;
  message: string = ''; isRedAlert: boolean = true;

  constructor(public localService: LocalService, private offcanvasService: NgbOffcanvas, private printerService: PrinterService, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      save_receipt_template: 'save-receipt-template-' + this.htmlId,
      receipt_options: 'receipt-options-' + this.htmlId
    };
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.loadedApi = 0;
    this.onGetTemplate();
    this.onGetPrinterName();
  }

  onGetTemplate() {
    this.itemSourceTemplates = [];
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
    this.printerService.getPrinterTemplates(req).subscribe(result => {
      result.forEach(item => {
        this.itemSourceTemplates.push({
          key: item.Key,
          value: item.Title
        } as KeyValueSet);
      });
      this.onLoadItem();
    });
  }

  onGetPrinterName() {
    this.itemSourcePrinterNames = [];
    this.configurationManagementService.getActiveLocalPrinterNamesMin(this.businessId).subscribe(result => {
      result.forEach(item => {
        this.itemSourcePrinterNames.push({
          key: item.key,
          value: [item.v1, item.v2].join('/')
        } as KeyValueSet);
      });
      this.onLoadItem();
    });
  }

  onLoadItem() {
    this.loadedApi++;
    if (this.loadedApi == 2) {
      if (this.itemId) {
        const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
        this.printerService.getPrinterTemplateMap(req, this.itemId).subscribe(result => {
          if (result.Status && result.Status == Status.Success) {
            this.title = result.Title;
            this.selectedKeysTemplates = result.PrinterTemplateIds.map(x => x.toString());
            this.selectedKeyPrinterName = result.PrinterNameId;
            this.onSetSelectedItems();
          }
        });
      } else {
        this.title = '';
        this.selectedKeysTemplates = [];
        this.selectedKeyPrinterName = '';
      }
      this.loadedApi++;
    }
  }

  onSetSelectedItems() {
    this.itemSourceTemplates.forEach(item => {
      item.isSelected = this.selectedKeysTemplates.includes(item.key);
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        if (this.onDoCheck()) {
          const req = {
            BusinessId: this.businessId,
            Key: this.itemId,
            Title: this.title.trim(),
            PrinterTemplateIds: this.selectedKeysTemplates,
            PrinterNameId: this.selectedKeyPrinterName
          } as req.PrinterTemplateMap;

          this.printerService.savePrinterTemplateMap(req).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onCloseTrigger();
            }
          });
        }
      } break;
    }
  }

  onDoCheck(): boolean {
    this.selectedKeysTemplates = this.itemSourceTemplates.filter(x => x.isSelected).map(x => x.key);
    let isPassed = true;
    let message = '';
    if (!this.title.trim()) {
      message = this.localService.languageContent.printer.titleRequired;
      isPassed = false;
    } else if (!this.selectedKeyPrinterName) {
      message = this.localService.languageContent.printer.printerNameRequired;
      isPassed = false;
    } else if (this.selectedKeysTemplates.length == 0) {
      message = this.localService.languageContent.printer.minReceiptTemplateMapRequired;
      isPassed = false;
    }

    this.message = message;
    return isPassed;
  }
}
